import { render, staticRenderFns } from "./AdminGatewayTypeDetails.vue?vue&type=template&id=57b6a728&"
import script from "./AdminGatewayTypeDetails.vue?vue&type=script&lang=ts&"
export * from "./AdminGatewayTypeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports